import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { firestore } from '../firebase';

export const writeActivityLog = async ({
  orgId = null,
  entityType,
  entityId = null,
  entityName = null,
  event,
  changedBy = null,
  changedByName = null,
  diff = null,
  meta = {},
}) => {
  try {
    await addDoc(collection(firestore, 'Logs'), {
      orgId: orgId || null,
      entityType,
      entityId,
      entityName,
      event,
      source: 'user',
      changedBy,
      changedByName,
      changedAt: serverTimestamp(),
      diff,
      ...meta,
    });
  } catch (err) {
    console.error('writeActivityLog error:', err);
  }
};
// src/api/activityLog.js — add this export
export const writeErrorLog = async ({ orgId, userId, userName, error, context = {} }) => {
  try {
    await addDoc(collection(firestore, 'Logs'), {
      orgId: orgId || null,
      entityType: 'frontend_error',
      event: 'error',
      source: 'error',
      changedBy: userId || null,
      changedByName: userName || null,
      changedAt: serverTimestamp(),
      errorMessage: error?.message || String(error),
      errorStack: error?.stack || null,
      ...context,
    });
  } catch (e) {
    // silent — don't recurse
  }
};